import { render, staticRenderFns } from "./DeliverProvidersForm.vue?vue&type=template&id=c1735f98"
import script from "./DeliverProvidersForm.vue?vue&type=script&lang=ts"
export * from "./DeliverProvidersForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports